import { render, staticRenderFns } from "./WeeklyWorkLabUpdate.vue?vue&type=template&id=0573bddb"
import script from "./WeeklyWorkLabUpdate.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkLabUpdate.vue?vue&type=script&lang=js"
import style0 from "./WeeklyWorkLabUpdate.vue?vue&type=style&index=0&id=0573bddb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports